import axios from 'axios'
import {NOTIFICATION_DANGER} from "../../constants/common";
// initial state
const state = {
    loading : false,
    faq: [],
    tags: [],
    activeTags: [],
};

// getters
const getters = {

};

// actions
const actions = {
    getFaq({commit}) {
        commit('setFaq', []);
        commit('setLoading', true);
        //todo: для симуляции загрузки, потом удалить
        setTimeout(() => {
            axios.get('/api/faq-questions.json')
                .then((response) => {
                    commit('setFaq', response.data.faq);
                    commit('setLoading', false);
                })
                .catch((response) => {
                    console.log(response);
                    this.dispatch('pushNotification', {type: NOTIFICATION_DANGER, text: "Server error", time: 10000})
                });
        },1000);
    },
    sendQuestion({commit}, {message, category, publish}) {
        return new Promise((resolve) => {
            //todo: для симуляции загрузки, потом удалить
            setTimeout(() => {
                axios.post('/test/post-request/', { category: category, message: message, publish: publish })
                    .then(() => {
                        commit('fake', false);
                    })
                    .catch((response) => {
                        console.log(response);
                        this.dispatch('pushNotification', {type: NOTIFICATION_DANGER, text: "Server error", time: 10000})
                    });
                resolve()
            }, 1000)
        });
    },
    getAllTags({commit}) {
        return new Promise((resolve, reject) => {
            axios.get('/api/base-tags.json')
                .then((response) => {
                    commit('setTags', response.data.tags);
                    resolve()
                })
                .catch((response) => {
                    console.log(response);
                    this.dispatch('pushNotification', {type: NOTIFICATION_DANGER, text: "Server error", time: 10000});
                    reject()
                });
        });
    },
};

// mutations
const mutations = {
    setLoading(state, value) {
        state.loading = value;
    },
    setActiveTag(state, id) {
        let inArr = state.activeTags.indexOf(id);
        if(inArr === -1) {
            state.activeTags.push(id)
        } else {
            state.activeTags.splice(inArr, 1)
        }
    },
    setActiveTags(state, tags) {
        state.activeTags = tags
    },
    setFaq (state, faq) {
        state.faq = faq
    },
    setTags (state, tags) {
        state.tags = tags
    },
    fake() {

    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}